/* SolutionsManager.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");

class SolutionsManager extends EventEmitter {
    constructor(steveDi, router) {
        super();
        this._di = steveDi;
        this._router = router;

        this._router.onPathTokenChange(
            "sln",
            (this._solutionChanged = this._solutionChanged.bind(this))
        );

        this._loadSolution();
    }

    // static getNavMap(_steve=window.steve){
    //
    //
    //     let _utils = _.get(_steve, "utils", _.get(_steve, "util", undefined));   // support new and old steve
    //     let _userSession = _.get(_steve, "userSession", _.get(_steve, "user.session", undefined)); // support new and old steve
    //     let token = _.get(_userSession,"token",undefined);
    //     let map = _.cloneDeep(SolNavMap);
    //     map.forEach((item)=>{
    //         let rdObject = {
    //             token: token
    //         };
    //         if(item.routeData){
    //             Object.assign(rdObject,item.routeData);
    //         }
    //         let rd = JSON.stringify(rdObject);
    //         let hash = _utils.b64EncodeUnicode(rd);
    //         item.path = window.location.origin + item.path + hash;
    //     });
    //     return map;
    // }

    get allSolutions() {
        return this._allSolutions;
    }

    get activeSolution() {
        return this.getActiveSolution();
    }

    getSolutionGroupNames() {
        if (!this.allSolutions) {
            this.updateSolutions();
        }
        let groups = {};
        Object.keys(this.allSolutions).forEach((nameSpace) => {
            let groupName = nameSpace.split(".")[1];
            if (groupName) {
                groups[groupName] = true;
            } else {
                groups.Solutions = true;
            }
        });
        return Object.keys(groups);
    }

    getSolutionsForGroup(groupName) {
        if (!this.allSolutions) {
            this.updateSolutions();
        }
        let nameSpace = "Solutions";
        if (groupName && groupName !== "Solutions") {
            nameSpace += "." + groupName;
        }
        return _.get(this._allSolutions, nameSpace);
    }

    getSolutionDetails(fqn) {
        return _.get(this._allSolutions, fqn + ".registeredObject");
    }

    updateSolutions() {
        this._allSolutions = this._di.getAllRegisteredByGlob("Solutions.**");
    }

    getSolutionUrl(solutionName) {
        let solution = this._di.getRegistered(
            ["Solutions", "Solutions.Utility", "Solutions.Administration"],
            solutionName
        );
        let _steve = window.steve;
        let _utils = _.get(_steve, "utils", _.get(_steve, "util", undefined)); // support new and old steve
        let rd = {};

        if (solution.registeredObj.steve2Path) {
            rd = JSON.stringify(rd);
            let hash = _utils.b64EncodeUnicode(rd);
            return (
                this._router._window.location.origin +
                solution.registeredObj.steve2Path +
                "/rd/" +
                hash
            );
        }

        let routeDets = {
            app: solution.registeredObj.app,
            s: solution.registeredObj.section,
            sln: solutionName,
        };
        if (solution.registeredObj.routeData) {
            rd = Object.assign(rd, solution.registeredObj.routeData);
        }
        routeDets.rd = rd;
        return this._router.buildUrl(this._router._window.location.origin, routeDets);
    }

    _solutionChanged() {
        this._loadSolution();
    }

    _loadSolution(solutionName) {
        let solution = null;
        if (_.isUndefined(solutionName)) {
            solutionName = this.getSolutionName();
        }

        if (solutionName) {
            solution = this._di.getRegistered(
                ["Solutions", "Solutions.Utility", "Solutions.Administration"],
                solutionName
            );
        }

        this._activeSolution = solution && solution.registeredObj;
        this.emit("activeSolutionChanged", this._activeSolution || {});
    }

    getSolutionName() {
        let routeDeets = this._router.getRouteDetails();
        return routeDeets.sln;
    }

    getActiveSolution() {
        return this._activeSolution;
    }

    shutdown() {
        this._router.removePathTokenChangeListener("sln", this._solutionChanged);
    }
}

module.exports = SolutionsManager;

module.exports.$inject = ["$teve.di", "$teve.router"];
